var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { uniq, difference } from "lodash";
var LOCAL_PEER_CHAT_COLOR = "#029bd4";
var DEFAULT_GUEST_PEER_CHAT_COLOR = "#20986c";
var GUEST_PEERS_CHAT_COLORS = ["#20986c", "#431eac", "#3978be", "#41a558", "#6300bf", "#0064b8", "#14988d", "#0041b9"];
export default {
    state: {
        chatFeatureEnabled: false,
        chatPanelOpened: true,
        localChatPeerId: undefined,
        peersColors: {},
        newMessageIndicator: false,
        messages: [],
    },
    getters: {
        showChat: function (state) {
            return state.chatFeatureEnabled && state.chatPanelOpened;
        },
        chatFeatureEnabled: function (state) {
            return state.chatFeatureEnabled;
        },
        chatPanelOpened: function (state) {
            return state.chatPanelOpened;
        },
        chatMessages: function (state) {
            return state.messages.sort(function (message1, message2) { return message1.index - message2.index; });
        },
        localChatPeerId: function (state) {
            return state.localChatPeerId;
        },
        getPeerColor: function (state) { return function (peerId) {
            return state.peersColors[peerId] || DEFAULT_GUEST_PEER_CHAT_COLOR;
        }; },
        getPeersWithColor: function (state) {
            return Object.keys(state.peersColors);
        },
        showNewMessageIndicator: function (state) {
            return state.newMessageIndicator && !state.chatPanelOpened;
        },
    },
    mutations: {
        addChatMessages: function (state, newMessages) {
            state.messages = __spreadArrays(state.messages, newMessages);
        },
        setChatFeatureEnabled: function (state, newChatFeatureStatus) {
            state.chatFeatureEnabled = newChatFeatureStatus;
        },
        setChatPanelOpened: function (state, newOpenedStatus) {
            state.chatPanelOpened = newOpenedStatus;
            if (!newOpenedStatus)
                state.newMessageIndicator = false;
        },
        setLocalChatPeerId: function (state, newPeerId) {
            state.localChatPeerId = newPeerId;
        },
        setLocalChatPeerColor: function (state, newPeerId) {
            var _a;
            state.peersColors = __assign(__assign({}, state.peersColors), (_a = {}, _a[newPeerId] = LOCAL_PEER_CHAT_COLOR, _a));
        },
        setPeerChatColor: function (state, newPeerId) {
            var _a;
            var colorIndex = Object.keys(state.peersColors).length % GUEST_PEERS_CHAT_COLORS.length;
            var color = GUEST_PEERS_CHAT_COLORS[colorIndex];
            state.peersColors = __assign(__assign({}, state.peersColors), (_a = {}, _a[newPeerId] = color, _a));
        },
        setNewMessageIndicator: function (state, newStatus) {
            state.newMessageIndicator = newStatus;
        },
        deleteChatMessage: function (state, deletedMessageIndex) {
            state.messages = state.messages.map(function (message) {
                if (message.index === deletedMessageIndex) {
                    return __assign(__assign({}, message), { content: "This message has been deleted.", deleted: true });
                }
                return message;
            });
        },
        deleteAllChatMessages: function (state) {
            state.messages = [];
        },
    },
    actions: {
        toggleChatPanelOpened: function (_a) {
            var getters = _a.getters, commit = _a.commit;
            commit("setChatPanelOpened", !getters.chatPanelOpened);
        },
        gotChatMessages: function (_a, newMessages) {
            var getters = _a.getters, commit = _a.commit;
            var messagePeers = uniq(newMessages.map(function (message) { return message.peersIdentifier; }));
            var newPeers = difference(messagePeers, getters.getPeersWithColor);
            if (newPeers.length > 0) {
                newPeers.forEach(function (peerId) { return commit("setPeerChatColor", peerId); });
            }
            commit("addChatMessages", newMessages);
            if (!getters.chatPanelOpened)
                commit("setNewMessageIndicator", true);
        },
        enableChat: function (_a, _b) {
            var commit = _a.commit;
            var peersIdentifier = _b.peersIdentifier;
            commit("setChatFeatureEnabled", true);
            commit("setChatPanelOpened", true);
            commit("setLocalChatPeerId", peersIdentifier);
            commit("setLocalChatPeerColor", peersIdentifier);
        },
        disableChat: function (_a) {
            var commit = _a.commit;
            commit("setChatFeatureEnabled", false);
            commit("setChatPanelOpened", false);
            commit("setLocalChatPeerId", undefined);
        },
    },
};



//////////////////
// WEBPACK FOOTER
// ./src/store/chat.ts
// module id = 344
// module chunks = 1